import React, {useState, useEffect} from 'react';
import * as S from './ProfileInfo.styles';
import {useSelector, useDispatch} from 'react-redux';
import {makePostRequest, profileInfoSelector} from '@ibibo/myaccount-reducer';
import UpdateDetailsForm from '../../../common/Form/UpdateDetailsForm/UpdateDetailsForm';
import Modal, {useModal} from '../../../../../../../hotels-dweb/src/shared/components/Modal';
import OtpVerfied from '../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';

const ProfileInfo = ({}) => {
  const dispatch = useDispatch();
  const profileInfo = useSelector(profileInfoSelector);

  const {isModalOpen, openModal, closeModal} = useModal();

  const [openModalFlag, setOpenModalFlag] = useState(false);
  const [modalData, setModalData] = useState({});
  const [popupType, setPopupType] = useState('');
  const [currentModalRow, setCurrentModalRow] = useState('');
  const [communicationAddress, setCommunicationAddress] = useState('');
  const errorsInitialState = {
    formSubmissionError: '',
    inputBoxError: '',
  };
  const [error, setError] = useState(errorsInitialState);
  const [componentData, setComponentData] = useState({});
  const [modalUpdateDetailsData, setModalUpdateDetailsData] = useState({
    componentData: {},
    modalData: {},
    formFields: {},
  });

  useEffect(() => {
    if (profileInfo?.show_mobile_verification_popup) {
      setComponentData(profileInfo?.mobile);
      //openModal();
      modalClickHandler('', profileInfo?.mobile?.POPUP_TYPE, 'mobile', '');
    }
  }, [profileInfo]);

  useEffect(() => {
    if (currentModalRow && popupType) {
      setModalData(profileInfo[currentModalRow][popupType]);
    }
  }, [popupType, currentModalRow]);

  const openVerificationPopup = () => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    setPopupType('');
  };

  const modalClickHandler = (data, popupClicked, rowItem, rowData) => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    //setModalData(data);
    setCurrentModalRow(rowItem);
    setPopupType(popupClicked);
    setModalUpdateDetailsData(prevState => ({
      ...prevState,
      modalData: profileInfo?.[rowItem]?.data?.[popupClicked],
    }));
  };

  const popupSuccessCallback = resp => {
    if (resp?.data?.POPUP_TYPE) {
      setOpenModalFlag(true);
    }
    const step = resp?.data?.step;
    if (step) {
      setModalUpdateDetailsData(prevState => ({
        ...prevState,
        modalData: profileInfo?.[currentModalRow]?.data?.[step],
      }));
    }

    setPopupType(resp?.data?.POPUP_TYPE || resp?.data?.step);
    setCommunicationAddress(resp?.data);
    setError(errorsInitialState);
  };

  const popupErrorCallback = err => {
    setError({...err, formSubmissionError: err.message});
  };

  const closeFormModal = () => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    setError({...error, formSubmissionError: ''});
  };

  const setDataForModalChange = ({...args}) => {
    setModalData({...args?.modalData});
  };

  return (
    <S.ProfileMainWrap>
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>{profileInfo?.heading}</S.HeadMainText>
            <S.HeadSubText>{profileInfo?.sub_heading}</S.HeadSubText>
          </S.ProfileHeadInnerWrap>
        </S.ProfileHeadOuterWrap>
        {profileInfo?.key_list?.length &&
          profileInfo?.key_list.map((item, key) => {
            return (
              profileInfo[item]?.key && (
                <S.ProfileInfoOuterWrap key={key}>
                  <S.ProfileInfoInnerWrap>
                    <S.InfoTitleWrap>
                      <S.TitleText>{profileInfo[item]?.key}</S.TitleText>
                    </S.InfoTitleWrap>
                    <S.InfoTextWrap>
                      <S.InfoText>{profileInfo[item]?.value}</S.InfoText>
                      <S.VerifyEmailLink
                        onClick={e =>
                          modalClickHandler(
                            profileInfo[item][profileInfo[item]?.POPUP_TYPE],
                            profileInfo[item]?.POPUP_TYPE,
                            item,
                            profileInfo[item],
                          )
                        }
                      >
                        {profileInfo[item]?.is_editable ? profileInfo[item]?.is_editable_text : ''}
                      </S.VerifyEmailLink>
                      <S.InfoSubText>{profileInfo[item]?.sub_text}</S.InfoSubText>
                    </S.InfoTextWrap>
                  </S.ProfileInfoInnerWrap>
                </S.ProfileInfoOuterWrap>
              )
            );
          })}
      </S.ProfileInnerWrap>
      {openModalFlag && (
        <Modal
          isOpen={openModalFlag}
          closeModal={closeFormModal}
          hideCloseButton={true}
          modalStyles={{
            width: '60rem',
          }}
        >
          {popupType === 'OTP_VERIFIED' || popupType === 'VERIFICATION_SUCCESS' ? (
            <OtpVerfied
              heading={communicationAddress?.heading}
              subHeading={communicationAddress?.text}
              headingIcon={true}
              inportantInfo={communicationAddress?.sub_text}
            />
          ) : (
            <UpdateDetailsForm
              {...modalData}
              successCallback={popupSuccessCallback}
              errorCallback={popupErrorCallback}
              errorMessages={error}
              closeModal={closeFormModal}
              componentData={componentData}
              setModalUpdateDetailsData={setDataForModalChange}
            />
          )}
        </Modal>
      )}
    </S.ProfileMainWrap>
  );
};

export default ProfileInfo;
